export const ADD_ATHLETE_ACCOUNT_ID = "ADD_ATHLETE_ACCOUNT_ID";

export const REMOVE_ATHLETE_ACCOUNT_ID = "REMOVE_ATHLETE_ACCOUNT_ID";

export const ADD_GYM_ACCOUNT_ID = "ADD_GYM_ACCOUNT_ID";

export const REMOVE_GYM_ACCOUNT_ID = "REMOVE_GYM_ACCOUNT_ID";

export const ADD_GYM_DATA = "ADD_GYM_DATA";

export const ADD_USER_DATA = "ADD_USER_DATA";

export const WORKOUT_API_CALLED = "WORKOUT_API_CALLED";

export const ADD_TRACK_INFO = "ADD_TRACK_INFO";

export const DATE_CHANGED = "DATE_CHANGED";

export const USER_UPDATED = "USER_UPDATED";

export const TRACK_CHANGED = "TRACK_CHANGED";

export const SELECTED_GYM = "SELECTED_GYM";

export const SELECTED_ATHLETE = "SELECTED_ATHLETE";

export const UNSELECT_ATHLETE = "UNSELECT_ATHLETE";

export const GYM_LIST = "GYM_LIST";

export const Is_Duplicate = "Is_Duplicate";

export const ADD_CONNECTED_ACCOUNT_ID = "ADD_CONNECTED_ACCOUNT_ID";

export const NEW_MESSAGE_NOTIFICATION = "NEW_MESSAGE_NOTIFICATION";

export const NEW_NON_MESSAGE_NOTIFICATION = "NEW_NON_MESSAGE_NOTIFICATION";
